var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36.9365 9.42752C35.6641 9.99034 34.3148 10.36 32.9332 10.5242C34.3894 9.65324 35.4794 8.28254 35.9998 6.66752C34.6332 7.48085 33.1348 8.05085 31.5732 8.35919C30.5242 7.23682 29.1338 6.49246 27.6181 6.24183C26.1024 5.9912 24.5464 6.24834 23.192 6.97328C21.8375 7.69821 20.7605 8.85033 20.1284 10.2505C19.4962 11.6507 19.3444 13.2205 19.6965 14.7159C16.925 14.5769 14.2137 13.8567 11.7387 12.602C9.26358 11.3472 7.08006 9.58593 5.32984 7.43252C4.71033 8.49661 4.38477 9.70623 4.38651 10.9375C4.38651 13.3542 5.61651 15.4892 7.48651 16.7392C6.37986 16.7043 5.29756 16.4055 4.32984 15.8675V15.9542C4.33018 17.5637 4.88713 19.1235 5.90626 20.3693C6.92539 21.615 8.34398 22.47 9.92151 22.7892C8.8942 23.0676 7.81702 23.1086 6.77151 22.9092C7.21629 24.2946 8.08319 25.5062 9.25083 26.3744C10.4185 27.2426 11.8284 27.7238 13.2832 27.7509C11.8373 28.8864 10.1818 29.7258 8.41131 30.2211C6.64082 30.7165 4.79006 30.8579 2.96484 30.6375C6.15101 32.6866 9.86001 33.7744 13.6482 33.7709C26.4698 33.7709 33.4815 23.1492 33.4815 13.9375C33.4815 13.6375 33.4732 13.3342 33.4598 13.0375C34.8246 12.0511 36.0025 10.8292 36.9382 9.42919L36.9365 9.42752Z",
    fill: "#202124"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.2f793530c8c78bd716f916581f22cf37.svg";
export { ForwardRef as ReactComponent };